module.exports = __webpack_public_path__ + "img/najim.436d2497.jpg";